module.exports = __webpack_public_path__ + "img/x.96e4c017.svg";